import React from "react";

export default function preventDefaultKeyboardShortcuts(
  e: KeyboardEvent | React.KeyboardEvent
) {
  if (["a", "d", "s", "y", "z"].includes(e.key) && (e.ctrlKey || e.metaKey)) {
    e.preventDefault();
  }
}
